import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const scrollAnimation = () => {
  const targets = document.querySelectorAll('.js-animation');
  if (!targets.length) return;
  gsap.registerPlugin(ScrollTrigger);

  targets.forEach((target) => {
    ScrollTrigger.create({
      trigger: target,
      start: 'top 75%',
      once: true,
      toggleClass: {
        targets: target,
        className: 'is-animated'
      },
    });
  });
};

export default scrollAnimation();
